export default {
  title: "[[HWR]]",
  number: "No.",
  general: {
    billedAt: "Billed at",
    draftedAt: "Invoice draft created at",
    lastPrintedAt: "Last printed at",
  },
  form: {
    general: {
      categories: "Categories",
      startdate: "Execution Date",
      description: "Description of the execution",
      tags_included: "Tags included",
      attachment: {
        label: "Attach to [[cr]]",
        project_default: "Project default",
        attached: "Attach",
        separate: "Don't attach",
        hint_attached:
          "The costs are contained in the [[cr]]. The post-calculation lists the report, but does not count it again.",
        hint_attached_no_report:
          "The project has no [[cr]] yet. Until it has one, the post-calculation counts the costs separately.",
        hint_attached_refused: "The project has no [[cr]] yet. To save, create one first or choose “Don't attach”.",
        hint_attached_unknown:
          "Once the project has [[cr:a/an]] [[cr]], the costs are contained in it and are not counted again. Until then the post-calculation counts them separately.",
        hint_separate: "The costs are counted separately in the post-calculation.",
        construction_report: "[[Cr]]",
        construction_report_optional: "[[Cr]] (optional)",
        construction_report_hint: "Without a choice, the [[cr]] is determined from the execution date when saving.",
        construction_report_automatic_hint:
          "Determined automatically from the execution date. You can pick a different one here.",
        construction_report_empty: "No [[cr.pl]] found",
      },
    },
    list_empty_hint: "Search and pick one using the field above.",
    machines: {
      // A line books one device; the same device twice at the same price would bill no further day.
      duplicate_device: "Already booked at this price: device number {devices}. Please change the existing line.",
      machine: "Choose Machine",
      machine_label: "Machine",
      add_machine: "Add a new Machine",
      amount: "Amount",
      duration: "Duration",
      duration_each: "Per device",
      // A line from before that counted several devices without a number becomes one line per device when edited.
      legacy_amount_hint:
        "Previously recorded as {amount} pieces without a device number. Each line now stands for one device: please enter the device numbers.",
      duration_unit: "Duration unit",
      billed: "= {quantity} {unit} billed (started day of use)",
      // A price row per week or month: the share the days of use are of the supplier's rental days.
      billed_week:
        "= {quantity} week billed ({days} of {per} rental days) | = {quantity} weeks billed ({days} of {per} rental days)",
      billed_month:
        "= {quantity} month billed ({days} of {per} rental days) | = {quantity} months billed ({days} of {per} rental days)",
      unit_unresolved:
        "No billing unit has been chosen for “{legacy}” yet. Please pick hour or day in the machine master data first.",
      legacy_duration_hint:
        "Previously recorded: {previous}. The duration is now entered in hours. Please enter it again.",
      amount_unit: "Piece",
      list_title: "Machines",
      list_empty: "No machines added yet",
    },
    materials: {
      material: "Choose Material",
      add_material: "Add a new Material",
      amount: "Amount",
      list_title: "Materials",
      list_empty: "No materials added yet",
    },
    additional_efforts: {
      additional_effort: "Choose an Additional Effort",
      add_additional_effort: "Add a new Additional Effort",
      amount: "Amount",
      list_title: "Additional Efforts",
      list_empty: "No additional efforts added yet",
    },
    users: {
      user: "Choose Employee",
      add_user: "Add a new Employee",
      duration: "Duration",
      positions: "Positions",
      no_positions: "No positions available",
      assigned: "Assigned",
      from_project: "Project",
      // Saving hands the position to the project server-side — without a rate, which is a
      // commercial decision. The project's tab reports the missing rate.
      not_in_project: "The position is added to the project.",
      list_title: "Employees",
      list_empty: "No employees added yet",
    },
    actions: {
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      remove: "Remove",
    },
  },
  table: {
    machines: {
      headers: {
        name: "Name",
        amount: "Amount",
        duration: "Duration",
        unit: "Unit",
      },
    },
    materials: {
      headers: {
        name: "Name",
        amount: "Amount",
        unit: "Unit",
      },
    },
    additional_efforts: {
      headers: {
        name: "Name",
        amount: "Amount",
        unit: "Unit",
      },
    },
    users: {
      headers: {
        firstname: "Fistname",
        lastname: "Lastname",
        duration: "Duration",
        position: "Position",
      },
    },
  },
  tabs: {
    general: "General",
    machines: "Machines",
    materials: "Materials",
    additional_efforts: "Additional Effort",
    users: "Employees",
    files: "Files",
    activity: "Activity",
  },
  // The dialog behind the cog of a report's tag field (LewHourlyWageReportTagOverview). A tag is only
  // its name: it is created or deleted, never renamed.
  tag_catalogue: {
    title: "Manage tags",
    subtitle: "The [[hwr]] tags of the whole company.",
    search: "Search tags",
    add: "Add tag",
    empty: "No tags yet.",
    no_match: "No tag matches the search.",
    count: "{count} tag | {count} tags",
    name: "Name",
    name_taken: "A tag with this name already exists.",
    delete_title: "Delete tag",
    delete_text: 'The tag "{name}" is removed from the choices. Reports that already carry it keep it.',
  },
  advanced_search: {
    advanced: "Advanced search",
    add_component: "Add Component",
    search: "Search",
    clear: "Clear",
    empty_title: "No filters added yet",
    empty: "Add a condition to build a custom search across your [[hwr.pl]].",
    tags_included: "Tags included",
    start_date_is: "Execution Date is",
    start_date_between_start: "Execution Date start",
    start_date_between_end: "Execution Date end",
    print_date_is: "Print Date is",
    print_date_between_start: "Print Date start",
    print_date_between_end: "Print Date end",
    last_modified_date_is: "Last Modified Date is",
    last_modified_date_between_start: "Last Modified Date start",
    last_modified_date_between_end: "Last Modified Date end",
    description_is: "description includes",
    create_date_is: "Create Date is",
    create_date_between_start: "Create Date start",
    create_date_between_end: "Create Date end",
    bundled_component_add: "Add Component",
    remove_condition: "Remove condition",
    toggle_logic: "Toggle AND / OR",
    pick_subtitle: "Choose what to filter by",
    pick_group_fields: "Fields",
    pick_group_dates: "Dates",
    pick_group_grouping: "Grouping",
    pick_description: "Description contains",
    pick_tags: "Tags",
    pick_start_date: "Execution date",
    pick_start_date_range: "Execution date range",
    pick_print_date: "Print date",
    pick_print_date_range: "Print date range",
    pick_create_date: "Creation date",
    pick_create_date_range: "Creation date range",
    pick_last_modified: "Last modified date",
    pick_last_modified_range: "Last modified date range",
    pick_group: "Condition group",
  },
  file: {
    // The checkbox on an attachment row decides whether the file is embedded in the printed PDF.
    // Both states are spelled out: the icon flips silently, so the label is the only thing that
    // says which way round it currently is. The file dialog carries the same checkbox as print_label.
    print_label: "Show in the printed PDF",
    print_included: "Included in the printed PDF",
    print_excluded: "Not included in the printed PDF",
    print_unsupported: "This file format cannot be included in the printed PDF",
    // File dialog only: the print shrinks pictures and the photos in PDFs, unless this is ticked.
    print_original_label: "Print in original quality",
    print_original_help:
      "Pictures and PDFs are made smaller in the print so the report can be sent by e-mail. Ticked, the file goes in unchanged.",
  },
  validation: {
    atLeastOneUserOrMachineOrMaterialOrEffort: "Add at least one Machine/Material/Employee/Additional Effort",
  },
}
